<template>
  <div class="navigation">
    <div class="navigationPc d-none d-lg-block">
      <div class="box">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="neirongBox">
                <ul>
                  <router-link active-class='active' tag='li' to="/home/index">
                    个人中心
                  </router-link>
                  <router-link exact tag='li' to="/about">
                    关于我们
                  </router-link>
                  <router-link exact tag='li' to="/about/tiaokuan">
                    购物指南
                  </router-link>
                  <router-link exact tag='li' to="/about/yinsi">
                    服务中心
                  </router-link>
                </ul>
                <ul>
                  <a :href="localUser?localUser.httpHost:''">
                    <li>
                      返回商城 <i class="iconfont icon-qianwang"></i>
                    </li>
                  </a>
                  <li @click="loginOutFun"><i class="iconfont icon-tuichu"></i> 退出</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navigationMobile d-block d-lg-none">
      <ul>
        <router-link tag='li' to="/">
          <i class="iconfont icon-shouye"></i>
          <span>首页</span>
        </router-link>
        <router-link tag='li' to="/home/order">
          <i class="iconfont icon-qinghuiyuan"></i>
          <span>订单</span>
        </router-link>
        <li @click="toBack" class="active">
          <i class="iconfont icon-shangcheng1"></i>
          <span>商城</span>
        </li>
        <router-link tag='li' to="/home/invoice">
          <i class="iconfont icon-wenjuan"></i>
          <span>发票</span>
        </router-link>
        <li @click="showMobileMenu=true">
          <i class="iconfont icon-gengduo1"></i>
          <span>更多</span>
        </li>
      </ul>
    </div>
    <div v-if="showMobileMenu" class="parentMenuBox" @click.self="showMobileMenu=false">
      <ul class="daohangBox">
        <li @click="toUrl('/home/cashback')">
          返现抵扣
        </li>
        <li @click="toUrl('/home/message')">
          我的消息
        </li>
        <li @click="toUrl('/home/info')">
          个人信息
        </li>
        <li @click="toUrl('/about')">
          关于我们
        </li>
        <li @click="toUrl('/about/tiaokuan')">
          购物指南
        </li>
        <li @click="toUrl('/about/yinsi')">
          服务中心
        </li>
        <li @click="showMobileMenu=false">
          <i class="iconfont icon-guanbi"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import commons from '@/util/commons';
export default {
  name: 'navigation',
  mixins: [generalMix],
  data() {
    return {
      showMobileMenu:false
    }
  },
  methods:{
    toUrl(url) {
      this.showMobileMenu = false;
      this.$router.push(url);
    },
    loginOutFun() {
      return window.swal({
        title: '确定退出吗?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          let httpHost = this.localUser.httpHost;
          // 删除本地存储
          const result = commons.saveTodos('localUser', null);
          if (result) {
            // 更新登陆状态
            this.saveLocaluserFun({ bool: false });
            // 提示
            this.$message.showMsgBox({
              type: 'success',
              content: '退出成功'
            });
            // 跳转首页
            window.location = httpHost + '/login/loginout.html';
          } else {
            this.$message.showMsgBox({
              type: 'danger',
              content: '退出失败'
            });
          }
        }
      });
    }
  },
  created(){
  },
  components:{
  }
}
</script>

<style scoped lang='less'>
.navigation{
  div.parentMenuBox{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ul.daohangBox{
      border-radius: 15px;
      color: #FFFFFF;
      overflow:hidden;
      li{
        cursor: pointer;
        font-weight: bold;
        text-align: center;
        line-height: 4em;
        padding: 0;
        width: 70vw;
        border-bottom: 1px solid #484848;
        background: #333333;
        &:active{
          background: #484848;
        }
        &:last-child{
          border: 0;
          i{
            font-size: 26px;
          }
        }
        &.active{
          background: rgba(255,255,255,0.2);
          background: #EFFF00;
          color: #000000;
          a{
            color: #000000;
          }
        }
        &:hover{
          background: rgba(255,255,255,0.2);
          background: #EFFF00;
          color: #000000;
          a{
            color: #000000;
          }
        }
        a{
          display: inline-block;
          width: 100%;
          padding: 10px 0;
          text-align: center;
          color: #FFFFFF;
          text-align: center;
        }
      }
    }
  }
  div.navigationMobile{
    position: fixed;
    width: 90%;
    bottom: 20px;
    left: 5%;
    border-radius: 35px;
    padding:8px 10px;
    background: #333333;
    z-index: 1;
    ul{
      flex: 1;
      display: flex;
      align-items: center;
      li{
        flex: 1;
        border-radius: 5px;
        cursor: pointer;
        margin-right: 5px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #FFFFFF;
        padding: 8px 0;
        &.active{
          background: rgba(255,255,255,0.1);
          border-radius: 35px;
        }
        &:last-child{
          margin: 0;
        }
        i{
          color: #FFFFFF;
          font-size: 20px;
        }
        span{
          font-size: 11px;
        }
      }
    }
  }
  div.navigationPc{
    height: 57px;
    div.box{
      position: fixed;
      width: 100%;
      background: #000000;
      top: 0;
      left: 0;
      z-index: 1;
      div.neirongBox{
        display: flex;
        color: #FFFFFF;
        justify-content: space-between;
        padding: 10px 0;
        ul, ol {
          list-style: none;
          margin: 0;
          display: flex;
          li{
            line-height: 2.6em;
            padding: 0 15px;
            border-radius: 5px;
            margin-right: 5px;
            cursor: pointer;
            &:hover{
              background: rgba(255,255,255,0.3);
            }
            &.active{
              background: rgba(255,255,255,0.3);
            }
          }
        }
        a{
          color: #FFFFFF;
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .navigation{
  }
}
@media (max-width: 992px) {
  .navigation{
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Navigation.vue